import React, { useEffect, useState, useContext, useCallback } from "react";
import axios from "axios";
import { AuthContext } from "../../../component/context/AuthContext";
import * as CONST from "../../../component/config/Constant";
import { toast } from "react-toastify";
import _ from "lodash";
import { IconCirclePlus } from "@tabler/icons-react";
import { IconTrash } from "@tabler/icons-react";
export default function AssignTest() {
  const [authUserData] = useContext(AuthContext);
  const token = authUserData && authUserData[0] ? authUserData[0].token : "";

  const [employees, setEmployees] = useState([]);
  const [questionSets, setQuestionSets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [limit] = useState(10);

  // State to track manual selections in the dropdowns
  const [localAssignments, setLocalAssignments] = useState({});

  useEffect(() => {
    fetchSets();
  }, []);

  useEffect(() => {
    fetchEmployees();
  }, [currentPage, searchTerm]);

  const fetchSets = async () => {
    try {
      const resp = await axios.get(CONST.ISO_QSET_LIST, {
        // Updated constant
        headers: { Authorization: `Basic ${token}` },
      });
      if (resp.data?.status === "success")
        setQuestionSets(resp.data.data || []);
    } catch (err) {
      toast.error("Failed to load question sets");
    }
  };

  const fetchEmployees = async () => {
    setLoading(true);
    try {
      const resp = await axios.get(`${CONST.ISO_ASSIGN_LIST}`, {
        headers: { Authorization: `Basic ${token}` },
        params: { page: currentPage, limit: limit, search: searchTerm },
      });
      if (resp.data?.status === "success") {
        setEmployees(resp.data.data || []);
        setTotalPages(resp.data.totalPages || 1);
      }
    } catch (err) {
      toast.error("Failed to load employees");
    }
    setLoading(false);
  };

  const handleSearch = useCallback(
    _.debounce((value) => {
      setSearchTerm(value);
      setCurrentPage(1);
    }, 500),
    [],
  );
  // 1. Handle Assigning a New Set
  const handleAssign = async (userId) => {
    const setId = localAssignments[userId];

    if (!setId) return toast.warning("Please select a set to assign");

    try {
      const resp = await axios.post(
        CONST.ISO_ASSIGN_TEST,
        { user_id: userId, question_set_id: setId },
        { headers: { Authorization: `Basic ${token}` } },
      );

      if (resp.data.status === "success") {
        toast.success("Set assigned successfully");
        setLocalAssignments({ ...localAssignments, [userId]: "" }); // Reset dropdown
        fetchEmployees(); // Refresh table
      } else {
        toast.error(resp.data.message || "Assignment failed");
      }
    } catch (err) {
      toast.error("Server error during assignment");
    }
  };

  // 1. Function for the small (x) icon on the black badges
  const handleDeleteAssignment = async (assignmentId) => {
     
      try {
        const resp = await axios.delete(
          `${CONST.ISO_ASSIGN_DELETE}${assignmentId}`,
          { headers: { Authorization: `Basic ${token}` } },
        );
        if (resp.data.status === "success") {
          toast.success("Assignment removed");
          fetchEmployees(); // Refresh the list
        }
      } catch (err) {
        toast.error("Failed to delete assignment");
      }
  };

  // 2. Function for the Red "Delete Set" Button
  const handleDelete = async (userId) => {
    const selectedSetId = localAssignments[userId];
    if (!selectedSetId)
      return toast.warning("Please select a set from the dropdown to delete");

    // Find the employee record in the current state
    const emp = employees.find((e) => e.id === userId);
    // Find the specific assignment ID for the selected question set
    const assignment = emp?.assigned_quiz?.find(
      (q) => String(q.question_set_id) === String(selectedSetId),
    );

    if (!assignment) {
      return toast.error("This set is not currently assigned to this employee");
    }

    // Reuse the delete logic
    await handleDeleteAssignment(assignment.id);
    // Clear the dropdown selection
    setLocalAssignments({ ...localAssignments, [userId]: "" });
  };

  
  return (
    <div className="container-xl p-1 min-vh-100 mt-3 ">
      {/* Page Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold text-muted mb-1">Assign Quiz to Employees</h4>
          <p className="text-muted small">
            Manage and track question set assignments per employee
          </p>
        </div>
      </div>

      {/* Search Section */}
      <div className="card shadow-sm border-0  bg-white border border-light p-3">
        <div className="row g-3 align-items-end mx-2">
          {/* Name Search */}
          <div className="col-md-2">
            <div className="form-group">
              <label className="form-label text-dark fw-bold small required ml-1">
                Name
              </label>
              <input
                type="text"
                className="form-control border-start-0"
                placeholder="Search Name or ID..."
                onChange={(e) => handleSearch(e.target.value)}
              />
            </div>
          </div>

          {/* Status Search */}

          {/* Action Buttons */}
          <div className="col-md-3">
            <div className="d-flex gap-2">
              <button
                type="button"
                className="btn btn-sm bg-blue text-white d-flex align-items-center mb-1 "
                onClick={(e) => handleSearch(e.target.value)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-search me-1"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <circle cx="10" cy="10" r="7"></circle>
                  <line x1="21" y1="21" x2="15" y2="15"></line>
                </svg>
                Search
              </button>
              {/* <button
                type="button"
                className="btn btn-sm btn-outline-secondary"
                onClick={handleReSetSearch}
              >
                Clear
              </button>
              <ExportCsv propsEmpName={filterUsers} propsHeaders={headers} /> */}
            </div>
          </div>
        </div>
      </div>

      {/* Table Card */}
      <div className="card shadow-sm border-0 rounded-3 bg-white">
        <div className="table-responsive">
          <table className="table table-vcenter table-mobile-md card-table bg-white text-dark mb-0">
            <thead>
              <tr className="border-bottom">
                <th className="bg-white ps-4 py-3 text-uppercase fw-bold text-dark small">
                  User ID
                </th>
                <th className="bg-white py-3 text-uppercase fw-bold text-dark small">
                  Employee Name
                </th>
                <th className="bg-white py-3 text-uppercase fw-bold text-dark small">
                  New Assignment
                </th>
                <th className="bg-white py-3 text-uppercase fw-bold text-dark small">
                  Active Sets
                </th>
                <th className="bg-white pe-4 py-3 text-uppercase fw-bold text-dark small text-end">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {loading ? (
                <tr>
                  <td colSpan="5" className="text-center py-5">
                    <div
                      className="spinner-border text-primary"
                      role="status"
                    ></div>
                    <div className="mt-2 text-muted">Fetching records...</div>
                  </td>
                </tr>
              ) : employees.length > 0 ? (
                employees.map((emp) => (
                  <tr key={emp.id} className="border-top">
                    <td className="pl-4">
                      <span className="badge badge-light border text-dark py-1 px-2">
                        {emp.id}
                      </span>
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-circle  text-blue d-flex align-items-center justify-content-center mr-3"
                          style={{
                            width: "35px",
                            height: "35px",
                            fontSize: "12px",
                          }}
                        >
                          {emp.first_name.charAt(0).toUpperCase()}
                          {emp.last_name.charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <div className="font-weight-bold text-dark">
                            {emp.first_name} {emp.last_name}
                          </div>
                          <div
                            className="text-muted small"
                            style={{ fontSize: "11px" }}
                          >
                            {emp.email}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <select
                        className="form-control form-control-sm border-0 bg-light shadow-none"
                        style={{ borderRadius: "6px" }}
                        value={localAssignments[emp.id] || ""}
                        onChange={(e) =>
                          setLocalAssignments({
                            ...localAssignments,
                            [emp.id]: e.target.value,
                          })
                        }
                      >
                        <option value="">-- Choose Set --</option>
                        {questionSets
                          .filter((set) => {
                            // Check if this specific set ID exists in the employee's assigned_quiz list
                            const alreadyExists = emp.assigned_quiz?.some(
                              (aq) =>
                                String(aq.question_set_id) === String(set.id),
                            );
                            // Only return true if it DOES NOT exist
                            return !alreadyExists;
                          })
                          .map((set) => (
                            <option key={set.id} value={set.id}>
                              {set.title}
                            </option>
                          ))}
                      </select>
                    </td>
                    <td>
                      <div className="d-flex flex-wrap" style={{ gap: "6px" }}>
                        {/* FILTER: Only show quizzes where status is 'assigned' */}
                        {emp.assigned_quiz &&
                        emp.assigned_quiz.filter((q) => q.status === "assigned")
                          .length > 0 ? (
                          emp.assigned_quiz
                            .filter((q) => q.status === "assigned")
                            .map((q, index) => (
                              <div
                                key={index}
                                className="d-flex align-items-center bg-primary text-white rounded px-2 py-1"
                                style={{
                                  fontSize: "11px",
                                  letterSpacing: "0.3px",
                                }}
                              >
                                <span className="me-2 text-uppercase">
                                  {q.set_details?.title || "Set"}
                                </span>
                                <i
                                  className="fa fa-times text-danger-light"
                                  style={{ cursor: "pointer", opacity: "0.8" }}
                                  onClick={() => handleDeleteAssignment(q.id)}
                                ></i>
                              </div>
                            ))
                        ) : (
                          <span className="text-muted small italic">
                            No active sets
                          </span>
                        )}
                      </div>
                    </td>
                    <td className=" ">
                      <div className="btn-group" style={{ gap: "8px" }}>
                        <IconCirclePlus
                          size={30}
                          stroke={2}
                          className="text-blue "
                          disabled={!localAssignments[emp.id]}
                          onClick={() => handleAssign(emp.id)}
                        />

                        <IconTrash
                          size={30}
                          stroke={2}
                          className="text-red "
                          disabled={!localAssignments[emp.id]}
                          onClick={() => handleDelete(emp.id)}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center py-5 text-muted">
                    No employees found matching your criteria.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card-footer d-flex justify-content-between bg-white border-top-1 py-3">
        <span className="text-muted small">
          Showing page {currentPage} of {totalPages}
        </span>
        <nav>
          <ul className="pagination pagination-sm mb-0">
            <li className={`page-item ${currentPage === 1 && "disabled"}`}>
              <button
                type="button"
                className="page-link"
                onClick={() => setCurrentPage((p) => p - 1)}
              >
                {"<<"}
              </button>
            </li>
            {[...Array(totalPages)].map((_, i) => (
              <li
                key={i}
                className={`page-item ${currentPage === i + 1 && "active"}`}
              >
                <button
                  type="button"
                  className="page-link"
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>
              </li>
            ))}
            <li
              className={`page-item ${currentPage === totalPages && "disabled"}`}
            >
              <button
                type="button"
                className="page-link"
                onClick={() => setCurrentPage((p) => p + 1)}
              >
                {">>"}
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
